import { Component } from 'react';
import globalCursor from './utils/globalCursor';





















export default class DragHandler extends Component


{
  constructor() {
    super();

    this.state = {
      isDragging: false,
      dragTarget: void 0
    };
  }

  onDrag = (e) => {
    const { button } = e;
    if (button === 2) {return void 0;} // Right-click

    e.preventDefault();
    e.stopPropagation();

    const { onDrag } = this.props;
    const { dragTarget } = this.state;
    const xPos = e.clientX;
    const yPos = e.clientY;

    onDrag({
      x: xPos >= 0 ? xPos : 0,
      y: yPos >= 0 ? yPos : 0,
      dragTarget
    });
  };

  startDrag = (e) => {
    const { dragContainerSelector } = this.props;
    const dragContent = document.querySelector(dragContainerSelector || 'body');

    if (!dragContent) {return;}

    const { cursor } = this.props;

    if (cursor) {
      globalCursor.set(cursor);
    }

    this.setState({ isDragging: true, dragTarget: e.target }, () => {
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    });
  };

  stopDrag = (e) => {
    this.onDrag(e);

    const { cursor } = this.props;

    if (cursor) {
      globalCursor.reset();
    }

    this.setState({ isDragging: false, dragTarget: void 0 }, () => {
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    });
  };

  render() {
    const { onDrag, children } = this.props;
    const { isDragging } = this.state;

    return children({ onMouseDown: onDrag ? this.startDrag : void 0, isDragging });
  }
}